import { Slider as OriginalSlider } from 'antd';
import { createElement } from 'react';
const Slider = (props) => {
    const { range } = props;
    let { defaultValue } = props;
    if (range) {
        defaultValue = Array.isArray(defaultValue)
            ? defaultValue
            : [0, defaultValue];
    }
    else {
        defaultValue = Array.isArray(defaultValue)
            ? defaultValue[1] || defaultValue[0]
            : defaultValue;
    }
    return (createElement(OriginalSlider, { ...props, defaultValue: defaultValue }));
};
export default Slider;
